var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "createPost-container" },
    [
      _c(
        "el-container",
        { staticStyle: { height: "100%" } },
        [
          _c(
            "el-header",
            { staticStyle: { padding: "0", height: "42px" } },
            [
              _c("sticky", { attrs: { className: "sub-navbar " } }, [
                _c(
                  "div",
                  { staticClass: "filter-container" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "postForm",
                        attrs: {
                          inline: true,
                          model: _vm.postForm,
                          rules: _vm.rules
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "name", label: "标题" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                size: "mini",
                                name: "name",
                                required: ""
                              },
                              model: {
                                value: _vm.postForm.name,
                                callback: function($$v) {
                                  _vm.$set(_vm.postForm, "name", $$v)
                                },
                                expression: "postForm.name"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "表单类型" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { size: "mini", placeholder: "" },
                                model: {
                                  value: _vm.postForm.frmType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.postForm, "frmType", $$v)
                                  },
                                  expression: "postForm.frmType"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "可拖拽动态表单", value: 2 }
                                }),
                                _c("el-option", {
                                  attrs: { label: "动态表单", value: 0 }
                                }),
                                _c("el-option", {
                                  attrs: { label: "自定义开发页面", value: 1 }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.postForm.frmType == 1
                          ? _c(
                              "el-form-item",
                              { attrs: { label: "系统自定义表单" } },
                              [
                                _vm.postForm.frmType == 1
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          size: "mini",
                                          placeholder: "请选择系统内置的页面"
                                        },
                                        model: {
                                          value: _vm.postForm.webId,
                                          callback: function($$v) {
                                            _vm.$set(_vm.postForm, "webId", $$v)
                                          },
                                          expression: "postForm.webId"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: {
                                            label: "请假条",
                                            value: "FrmLeaveReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "工程申请",
                                            value: "FrmProjectReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "水价变更",
                                            value: "FrmPriceChangeReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "过户",
                                            value: "FrmTransferReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "调整减免",
                                            value: "FrmUnverifiedAdjustmentReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "更名",
                                            value: "FrmRenameReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "停用",
                                            value: "FrmDeactivateReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "启用",
                                            value: "FrmActivateReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "注销",
                                            value: "FrmUnregisterReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "恢复",
                                            value: "FrmRegisterReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "换表",
                                            value: "FrmMeterReplaceReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "人口数调整",
                                            value: "FrmPopulationReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "阶梯水量调整",
                                            value: "FrmWaterChangeLevelReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "预存调整",
                                            value: "FrmAccountReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "已销调整",
                                            value: "FrmPaymentReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "违约金减免",
                                            value: "FrmLateFeeReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "分账调整",
                                            value: "FrmSeparateReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "价差调整",
                                            value: "FrmPriceReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "呆坏账调整",
                                            value: "FrmKnottyReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-用户申请",
                                            value: "FrmInstallApplyReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-现场踏勘",
                                            value: "FrmInstallSurveyReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-踏勘设计",
                                            value: "FrmInstallDesignReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-踏勘审核",
                                            value: "FrmInstallAuditReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-客户信息",
                                            value: "FrmInstallCustReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-缴费信息",
                                            value: "FrmInstallCostReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-合同信息",
                                            value: "FrmInstallContractReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-安装派工",
                                            value: "FrmInstallWorkerReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-派工回填",
                                            value: "FrmInstallBackfillReq"
                                          }
                                        }),
                                        _c("el-option", {
                                          attrs: {
                                            label: "报装-工程验收",
                                            value: "FrmInstallAcceptanceReq"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          { attrs: { label: "关联数据库表" } },
                          [
                            _c("auth-select", {
                              attrs: {
                                "default-props": {
                                  label: "tableName",
                                  value: "tableName"
                                },
                                type: "dynamic",
                                "data-source": "/BuilderTables/Load",
                                size: "mini"
                              },
                              model: {
                                value: _vm.postForm.dbName,
                                callback: function($$v) {
                                  _vm.$set(_vm.postForm, "dbName", $$v)
                                },
                                expression: "postForm.dbName"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "表单描述" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "300px" },
                              attrs: { size: "mini" },
                              model: {
                                value: _vm.postForm.description,
                                callback: function($$v) {
                                  _vm.$set(_vm.postForm, "description", $$v)
                                },
                                expression: "postForm.description"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.loading,
                                    expression: "loading"
                                  }
                                ],
                                attrs: { size: "mini" },
                                on: { click: _vm.submitForm }
                              },
                              [_vm._v("保存 ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _c(
            "el-main",
            { staticStyle: { padding: "0", height: "calc(100% - 42px)" } },
            [
              _vm.postForm.frmType === 0 || _vm.postForm.frmType === 2
                ? _c(
                    "div",
                    {
                      staticClass: "editor-container",
                      staticStyle: { height: "100%" }
                    },
                    [
                      _vm.postForm.frmType === 2
                        ? _c("v-form-designer", {
                            ref: "vfDesigner",
                            attrs: { "designer-config": _vm.designerconfig }
                          })
                        : _vm._e(),
                      _vm.postForm.frmType === 0
                        ? [
                            _c("Ueditor", {
                              ref: "ue",
                              attrs: {
                                content: _vm.postForm.content,
                                formType: _vm.postForm.frmType,
                                fileds: _vm.postForm.fields
                              },
                              on: { ready: _vm.ueReady }
                            })
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm.postForm.frmType == 1
                ? _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        _vm.postForm.webId != "" && _vm.postForm.webId + "Add",
                        { tag: "component" }
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }